import React from 'react'

export default function Forgetpassoword() {
  return (
    <div>Forgetpassoword</div>
  )
}
